module.exports = __webpack_public_path__ + "img/ic_20_delete.611cd16d.svg";